import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

const NAV_ITEMS = [
    {
        location: '/',
        label: 'Home',
    },
    {
        location: '/about',
        label: 'About',
    }
];

// const NON_USER_NAV_ITEMS = [
//     {
//         location: '/user/login',
//         label: 'Login',
//     }
// ];

// const USER_NAV_ITEMS = [
//     {
//         location: '/user/account',
//         label: 'Account',
//     }
// ];

class NavbarContainer extends Component {
    render() {
        // const { isLoggedIn } = this.props;

        // const navigation = NAV_ITEMS.concat(isLoggedIn ? USER_NAV_ITEMS : NON_USER_NAV_ITEMS)
        const navigation = NAV_ITEMS

        const navItems = navigation.map(item => (
            <NavLink
                key={item.location}
                to={item.location}
                exact={item.location === '/'}
                activeclassname="active"
                className="nav-item nav-link"
            >
                {item.label}
                <div className="nav-underline" />
            </NavLink>
        ))

        return (
            <nav className="navbar sticky-top navbar-light navbar-custom-style">
                <NavLink
                    key="/"
                    to="/"
                    className="navbar-brand"
                >
                    <img src={require('assets/imgs/house-atl.svg')} style={{ width: 85 }} alt="" />
                </NavLink>
                <div className="navbar-nav flex-row">
                    {navItems}
                </div>
            </nav>
        )
    }
};

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.auth.loggedIn,
    }
}

export default connect(mapStateToProps)(NavbarContainer);
